import filterConstants from '../constants';

const reportsBudgetResource = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsBudgetResource,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.portfolio_id]: '',
    [filterConstants.PROPERTY.text]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
    [filterConstants.PROPERTY.assignee]: '',
  },
});

export default reportsBudgetResource;
